import { create } from "zustand";
import type { EmailQuotation, InMemoryEmail } from "@/types/gmail";

type ClassifiedSessionEmail = EmailQuotation & { _sessionOnly: boolean };

interface EmailInboxStore {
  inMemoryEmails: InMemoryEmail[];
  existingFetchedEmails: EmailQuotation[];
  classifiedSessionEmails: ClassifiedSessionEmail[];

  setInMemoryEmails: (emails: InMemoryEmail[]) => void;
  filterInMemoryEmails: (predicate: (e: InMemoryEmail) => boolean) => void;

  setExistingFetchedEmails: (emails: EmailQuotation[]) => void;
  updateExistingFetchedEmails: (updater: (prev: EmailQuotation[]) => EmailQuotation[]) => void;

  setClassifiedSessionEmails: (emails: ClassifiedSessionEmail[]) => void;
  appendClassifiedSessionEmails: (emails: ClassifiedSessionEmail[]) => void;
  updateClassifiedSessionEmails: (updater: (prev: ClassifiedSessionEmail[]) => ClassifiedSessionEmail[]) => void;

  clearAll: () => void;
}

export const useEmailInboxStore = create<EmailInboxStore>((set) => ({
  inMemoryEmails: [],
  existingFetchedEmails: [],
  classifiedSessionEmails: [],

  setInMemoryEmails: (emails) => set({ inMemoryEmails: emails }),
  filterInMemoryEmails: (predicate) =>
    set((state) => ({ inMemoryEmails: state.inMemoryEmails.filter(predicate) })),

  setExistingFetchedEmails: (emails) => set({ existingFetchedEmails: emails }),
  updateExistingFetchedEmails: (updater) =>
    set((state) => ({ existingFetchedEmails: updater(state.existingFetchedEmails) })),

  setClassifiedSessionEmails: (emails) => set({ classifiedSessionEmails: emails }),
  appendClassifiedSessionEmails: (emails) =>
    set((state) => ({ classifiedSessionEmails: [...state.classifiedSessionEmails, ...emails] })),
  updateClassifiedSessionEmails: (updater) =>
    set((state) => ({ classifiedSessionEmails: updater(state.classifiedSessionEmails) })),

  clearAll: () =>
    set({ inMemoryEmails: [], existingFetchedEmails: [], classifiedSessionEmails: [] }),
}));
